import React from "react";
import { Box, Typography, Button, styled } from "@mui/material";

interface HeardOfDialogProps {
  onAnswer: (heardOf: boolean) => void;
}

const DialogContainer = styled(Box, {
  label: "HeardOfDialogContainer",
})(() => ({
  position: "absolute",
  top: "55%",
  left: 0,
  right: 0,
  backgroundColor: "rgba(239, 236, 236, 0.78)",
  paddingTop: 12,
  paddingBottom: 12,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  overflow: "hidden",
  boxShadow: "-40px 40px 80px -8px rgba(145, 158, 171, 0.24)",
  zIndex: 2,
}));

const Question = styled(Typography, {
  label: "HeardOfQuestion",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: "28px",
  color: "#1C252E",
  textAlign: "center",
  width: "100%",
}));

const ButtonRow = styled(Box, {
  label: "HeardOfButtonRow",
})(() => ({
  display: "flex",
  gap: 12,
  alignItems: "center",
  justifyContent: "center",
  padding: "6px 16px",
  borderRadius: 16,
  width: "100%",
}));

const ActionButton = styled(Button, {
  label: "HeardOfActionButton",
})(() => ({
  backgroundColor: "#ffffff",
  color: "#1C252E",
  textTransform: "none",
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 700,
  minWidth: 64,
  borderRadius: 8,
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
}));

export const HeardOfDialog = ({ onAnswer }: HeardOfDialogProps) => {
  return (
    <DialogContainer>
      <Question>Have you heard of this career before?</Question>
      <ButtonRow>
        <ActionButton size="small" onClick={() => onAnswer(true)}>
          Yes
        </ActionButton>
        <ActionButton
          variant="outlined"
          size="medium"
          onClick={() => onAnswer(false)}
          sx={{
            border: "1px solid rgba(145, 158, 171, 0.32)",
            height: 36,
            px: 1.5,
          }}
        >
          No
        </ActionButton>
      </ButtonRow>
    </DialogContainer>
  );
};
